<template>
    <div class="nft-spam-toggle" v-if="spamShown || spamCount > 0">
        <div class="nft-spam-toggle__button" tabindex="0"
            v-on:click="toggle"
            v-on:keyup.enter="toggle">
            <div class="nft-spam-toggle__icon">
                <icon-eye-closed v-if="spamShown"/>
                <icon-eye v-else/>
            </div>
            <div class="nft-spam-toggle__title" v-if="!isTablet && !isMobile">
                <span>{{ label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import IconEye from '@img/icons/lucide/eye.svg?vue';
import IconEyeClosed from '@img/icons/lucide/eye-off.svg?vue';
import { mapState } from 'vuex';

export default {
    computed: {
        label() {
            return this.spamShown
                ? this.$t('address.nfts.hide_hidden')
                : this.$tc('address.nfts.hidden_nfts', this.spamCount);
        },

        ...mapState({
            spamShown: 'nftSpamShown',
            spamCount: 'nftSpamCount',
        }),
    },

    methods: {
        toggle() {
            this.$store.commit('updateNftSpamShown', !this.spamShown);
        },
    },

    components: {
        IconEye,
        IconEyeClosed,
    },
};
</script>

<style lang="scss">
// Wrapper + button + icon repeat .filter and .calendar-button: all three
// buttons sit side by side in the tab header and have to line up.
.nft-spam-toggle {
    padding: 0 10px;
    position: relative;
    z-index: 90;
    &__button {
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;
        border-radius: 8px;
        padding: 0 8px;
        line-height: 36px;
        user-select: none;
        cursor: pointer;
        &:hover {
            .nft-spam-toggle__icon,
            .nft-spam-toggle__title {
                color: var(--body-text-color);
            }
        }
    }
    &__icon {
        display: flex;
        align-items: center;
        width: 18px;
        height: 36px;
        color: var(--body-muted-text-color);
        fill: currentColor;
        z-index: 1;
        svg {
            width: 100%;
            height: 100%;
        }
    }
    &__title {
        text-transform: uppercase;
        font-weight: 500;
        color: var(--body-muted-text-color);
        white-space: nowrap;
    }
}
@media screen and (max-width: 480px) {
    .nft-spam-toggle__button {
        padding: 0 5px;
    }
}
</style>
